import React from 'react';
import { createContext, MutableRefObject, useContext } from 'react';
import { AbsolutePositions } from '../Interfaces/Interfaces';

import { useAppContext } from './Context-API/AppContext';
import { Platform } from 'react-native';
import { CommonActions } from '@react-navigation/native';
import { isObject } from 'lodash';
import { addToStorage, getFromStorage } from './Storage';



interface NavigateDefault {
  navigation: any;
  data?: object;
}

interface NavigateToProps extends NavigateDefault {
  
  goTo: string,
  e?: any 
}


// ===== LOGIN
interface LoginProps {
  login: string;
  password: string;
}

export const webFont = (font: string) =>
  Platform.select({
    web: `${font}, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, Inter-serif`,
    default: font,
  })
export const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));


export const getAbsoultePositionsAPI = (Ref: MutableRefObject<any | null>): Promise<AbsolutePositions | false> => {
  return new Promise((resolve) => {
    if (Ref && Ref.current) {
      Ref.current.measure((x, y, width, height, pageX, pageY) => {
        resolve({
          x,
          y,
          width,
          height,
          pageX,
          pageY,
        });
      });
    } else {
      resolve(false);
    }
  });
};

// export const handleNavigate = (
//   e: any,
//   navigation,
//   goTo,
//   data?
// ) => {
//   if (e?.button === 1 || e?.ctrlKey || e?.metaKey) {
//     window.open(`/${goTo}`, '_blank');
//     return;
//   }

//   NavigateTo({ navigation, goTo, data });
// };

const buildUrl = (route: string, data?: object) => {
  if (!data) return `/${route}`;

  const params = new URLSearchParams({
    data: encodeURIComponent(JSON.stringify(data)),
  });

  return `/${route}?${params.toString()}`;
};



export const NavigateTo = ({e, navigation, goTo, data }: NavigateToProps) => {
  try {
    if (e && (e?.button === 1 || e?.ctrlKey || e?.metaKey)) {
      window.open(buildUrl(goTo, data), '_blank');
      return;
    }
    if (data) {
      navigation.navigate(goTo, data);
    } else {
      navigation.navigate(goTo);
    }
  } catch (e) {
    console.error('Error message:', e);
  }
};

export const NavigationHomeWithReset = ({ navigation, data }: NavigateDefault) => {
  try {
    navigation.dispatch(
      CommonActions.reset({
        index: 0,
        routes: [{ name: 'Home', params: data }], // Replace 'Home' with your actual screen name
      })
    );
  } catch (e) {
    console.error('Error resetting navigation:', e);
  }
};

interface getAllDataProps {
  mode?: 'allData' | 'dealers' | 'portfolio-list'
}

type SplitAllDataPart = 'units' | 'collections' | 'variant-groups' | 'about' | 'catalog' | 'meta';

interface sendUserRequestProps{
  email: string,
  name: string,
  question: string,
  extraData?: {
    [key: string] : string
  }
}


interface APIContextProps {
  getAllData: (x: getAllDataProps) => Promise<void>;
  sendUserRequest: (x: sendUserRequestProps) => Promise<any>;
  serverUrl: string;
  sendPostRequest: (
    json_data: Record<string, any> | null,
    link: string | null,
    errorHandler?: { handle: (error: any) => any } | null,
    contentTypeCall?: string,
    responseTypeCall?: string,
    performOnFalse?: (() => void) | null,
    signal?: AbortSignal | null,
    otherHeaderProps?: Record<string, string>
  ) => Promise<any>;
  sendFormDataPostRequest: (props: {
    formData?: FormData | null;
    link: string;
    errorHandler?: { handle: (error: any) => any } | null;
    contentTypeCall?: string;
    responseTypeCall?: string;
    otherHeaderProps?: Record<string, string>;
  }) => Promise<any>;
  refreshData: () => Promise<any>
}



const defaultAPIContext = {
  getAllData: async (
    x: getAllDataProps) => {},
  sendUserRequest: async (x: sendUserRequestProps) => {},
  serverUrl: 'https://deante.pro/',
  sendPostRequest: async (
    json_data: Record<string, any> | null,
    link: string | null,
    errorHandler?: { handle: (error: any) => any } | null,
    contentTypeCall?: string,
    responseTypeCall?: string,
    performOnFalse?: (() => void) | null,
    signal?: AbortSignal | null,
    otherHeaderProps?: Record<string, string>
  )  => {},
  sendFormDataPostRequest:(props: {
    formData?: FormData | null;
    link: string;
    errorHandler?: { handle: (error: any) => any } | null;
    contentTypeCall?: string;
    responseTypeCall?: string;
    otherHeaderProps?: Record<string, string>;
  }) => {},
  refreshData: () => {}
}as APIContextProps


const APIContext = createContext<APIContextProps>(defaultAPIContext);


export const APIProvider = ({ children }: {children: any}) => {
  
  const triggerNotification = (st: string) => {}
  const {X_API_TOKEN, ACCESS_TOKEN, setBootstrapData,
    setShowDiscountedPrices, showDiscountedPrices,
     setDealers, setPortfolioList, USER, setUSER, OTHER_INFO_FIELDS, setOTHER_INFO_FIELDS} = useAppContext()

  const serverUrl = process.env.NODE_ENV !== 'production' ? '/api/' : 
  'https://deante.pro/';

  function trimToValidJson(inputString: string) {
    let leftIndex = 0;
    let rightIndex = inputString.length;

    // Trim from the left until we find '{'
    while (leftIndex < rightIndex && inputString[leftIndex] !== '{') {
        leftIndex++;
    }

    // Check if there is any content to parse
    if (leftIndex >= rightIndex) {
        return null;
    }

    // Start trimming from the right until we find '}'
    while (rightIndex > leftIndex) {
        let trimmedString = inputString.substring(leftIndex, rightIndex);
        try {
            JSON.parse(trimmedString);
            return trimmedString;
        } catch (error) {
            rightIndex--;
        }
    }

    return null;
}


  const sendPostRequest = React.useCallback(async (
    json_data: Record<string, any> | null = null,
    link: string | null = null,
    errorHandler: ErrorHandler | null = null,
    contentTypeCall: string | null = 'application/json',
    responseTypeCall: string | null = 'application/json',
    performOnFalse: (() => void )| null,
    signal: AbortSignal | null = null, // Update the type of signal to AbortSignal
    otherHeaderProps: otherHeaderPropsProps = {}
): Promise<any> => {
    if (!link || !json_data) {
        console.log('You forgot to provide a link and data');
        return null;
    }

    try {
        console.log('json_data', json_data)

        const fetchOptions: RequestInit = {
            method: 'POST',
            headers: {
              'Content-Type': contentTypeCall || 'application/json',
              'x-api-key': X_API_TOKEN,
              'access-token': USER?.access_token || ACCESS_TOKEN,
              ...otherHeaderProps
            },
            body: JSON.stringify(json_data),
          };
      
          if (signal) {
            fetchOptions.signal = signal; // Only include signal if it's provided
          }
      
        const response = await fetch(link, fetchOptions);

        const contentType = response.headers.get('Content-Type');

        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(
                `HTTP error! status: ${response.status}, body: ${errorText}`,
            );
        }
        
        if(response.ok){

            // console.warn(response)
        

            if (
                responseTypeCall === 'application/json' ||
                responseTypeCall === 'user_register/json'
            ) {
                
        

                const data = trimToValidJson(await response.text());
             
                console.log('==============')
                if(data)
                console.log('==============')


               
                return JSON.parse(data);
            } else if (responseTypeCall === 'text/html') {
                const data = await response.text();
                console.log(data);
                return data;
            } else {
                console.log(response);
                if(response == null || typeof response == undefined ){
                  triggerNotification('SomethingWrong');
                }

                return response;
            }
        }else {
            if(response == null || typeof response == undefined ){
              triggerNotification('SomethingWrong');
            }
        }
    } catch (error) {
        if (errorHandler) {
            errorHandler.handle(error);
        }else {
            if (error.message.includes('Network request failed')) {
              triggerNotification('NoInternet');
            } else {
              triggerNotification('SomethingWrong');
            }
        }
        console.error('Error in sendPostRequest:', error);

        return null;
        
    }
}, [ACCESS_TOKEN, USER?.access_token, X_API_TOKEN]);

  interface ErrorHandler{
    handle: (error: any) => any 
  }

  interface otherHeaderPropsProps {
    'x-api-key'?: string,
    'access-token'?: string,
  }
  interface sendFormDataPostRequestProps{
    formData?: FormData | null,
    link: string,
    errorHandler?: ErrorHandler | null
    contentTypeCall?: string,
    responseTypeCall?: string
    otherHeaderProps?: otherHeaderPropsProps
  }

  const sendFormDataPostRequest = React.useCallback(async (
      {
        formData = null,
        link,
        errorHandler = null,
        contentTypeCall = 'application/json',
        responseTypeCall = 'application/json',
        otherHeaderProps =  {}

      } : sendFormDataPostRequestProps
  ): Promise<any> => {
      if (!link) {
          console.error('Link are required');
          return;
      }
      try {
        const headers = formData ? {} : { 'Content-Type': contentTypeCall || 'application/json' };
        // const serverUrl = 'https://deante.pro/'
        console.log('serverUrl + link', serverUrl + link)
        const response = await fetch(
          serverUrl + link, {
          method: 'POST',
          body: formData ?? undefined,
          headers: {
            'x-api-key': X_API_TOKEN,// X_API_TOKEN,
            'access-token': USER?.access_token || ACCESS_TOKEN,///ACCESS_TOKEN
            ...otherHeaderProps
          },
          ...headers,
        });
        
        if (!response.ok) {
          throw new Error('Failed to fetch');
        }
        if (response.status === 204) {
          console.log('No content returned');
        }
        const result = await response.json(); 
        return result;
      } catch (error) {
          console.error(error)
          if (errorHandler) {
              errorHandler.handle(error);
          } else {
              if (error.message.includes('Network request failed')) {
                
              } else {
              }
          }

          console.error('Error in sendFormDataPostRequest:', error);
          throw error;
      }
  }, [ACCESS_TOKEN, USER?.access_token, X_API_TOKEN, serverUrl]);


  const getAllData = async ({mode = 'allData' }:getAllDataProps) => {
    const tokens = getFromStorage({key: 'tokens'});

    if (mode === 'allData') {
      const parts: SplitAllDataPart[] = ['units', 'collections', 'variant-groups', 'about', 'catalog', 'meta'];

      const fetchSplitPart = async (part: SplitAllDataPart) => {
        const partFormData = new FormData();
        partFormData.append('part', part);

        if (tokens && tokens.access_token) {
          partFormData.append('access_token', tokens.access_token);
        }

        return sendFormDataPostRequest({
          link: 'get-app-data',
          formData: partFormData,
          otherHeaderProps: {
            'x-api-key': X_API_TOKEN,
          },
        });
      };

      try {
        const splitResponses = await Promise.all(parts.map(fetchSplitPart));
        const failedResponse = splitResponses.find(
          (response) => !response || !response.success || !response.data
        );

        if (failedResponse) {
          console.warn('split get-app-data failed, falling back to get-all-data', failedResponse);
          throw new Error(failedResponse?.message ?? 'split data request failed');
        }

        const mergedData = splitResponses.reduce((acc, response) => {
          return {
            ...acc,
            ...response.data,
          };
        }, {} as any);

        setBootstrapData(mergedData)
        return;
      } catch (e) {
        console.error('error at split getAllData, fallback to legacy get-all-data', e)
      }
    }

    const link = mode == 'allData' ? 'get-all-data' : mode == 'portfolio-list' ? 'portfolio-request' : 'get-dealers'
    console.warn(serverUrl + link, X_API_TOKEN)
    const formData = new FormData()
    if (mode == 'allData') {
      formData.append('getAll', '1');
    }

    if(tokens && tokens.access_token){
      formData.append('access_token', tokens.access_token);
    }

    try{
      const response = await sendFormDataPostRequest({
        link: link,
        formData:formData,
        otherHeaderProps: {
            'x-api-key' : X_API_TOKEN,
        }
      })
      if(response){
          // console.warn(response)

          if(response.success){
              if(mode == 'dealers'){
                setDealers(response.data)
              }else if (mode == 'portfolio-list') {
                setPortfolioList(response.data)
              }else {
                setBootstrapData(response.data)
              }
          }else {
            console.warn('not success at getAllData', mode, response.message ?? response )
          }
      }
    }catch(e){
      console.error('error at getAllData', mode, e)
    }
  }

  // ===== LOGIN: функция логина
  const login = async ({ login, password }: LoginProps) => {
    const link = 'login';
    console.warn(serverUrl + link, X_API_TOKEN);

    const formData = new FormData();
    formData.append('login', login);
    formData.append('password', password);

    try {
      const response = await sendFormDataPostRequest({
        link,
        formData,
        otherHeaderProps: {
          'x-api-key': X_API_TOKEN,
        },
      });

      // здесь можно сразу сохранить токен в контекст/AsyncStorage, если нужно
      if (response && response.success && response.access_token) {
        addToStorage({
          key: 'tokens', data: {
            access_token: response.access_token
          }
        })

        setUSER({
          access_token: response.access_token,
          role: response.role
        })

        if(response.role == 'admin'){
          await getUtils()
        }

        // console.log('')
      }


      return response;
    } catch (e) {
      console.error('error at login', e);
      throw e;
    }
  };

  const getUtils = async () => {
    try{
       if(USER){
        const formData = new FormData()
        formData.append('access_token', USER.access_token)
        const res = await sendFormDataPostRequest({
          link: 'get-utils',
          formData
        })
        if(res && res.success && res.utils){
          if(res.utils.OTHER_INFO_FIELDS){
            console.log('setOTHER_INFO_FIELDS', res.utils.OTHER_INFO_FIELDS)
            setOTHER_INFO_FIELDS(res.utils.OTHER_INFO_FIELDS)
            
          }
          return;
        }
        
      }else{

      }
    }catch(e){
      console.error('getUtils', e)
    }
   
  }

  const sendUserRequest = async ({
    email,
    name,
    question,
    extraData
  }: sendUserRequestProps) => {
    const link = 'user-request'
    console.warn(serverUrl + link, X_API_TOKEN)
    const formData = new FormData()
    formData.append('email', email);
    formData.append('name', name);
    formData.append('question', question);

    if(extraData && isObject(extraData) && Object.keys(extraData).length > 0){
      Object.keys(extraData).forEach(key => {
        formData.append(key, extraData[key])
      })
    }
    const response = await sendFormDataPostRequest({
      link: link,
      formData:formData,
      otherHeaderProps: {
          'x-api-key' : X_API_TOKEN,
      }
    })

    if(response && response.success){
      return response;
    }
    else 
      return response
  }

  const handleToggleDiscountSwitch = () => {
    setShowDiscountedPrices(!showDiscountedPrices);
    setTimeout(async () => {
        await getAllData({mode: 'allData'})
    })
  };

  const refreshData = async () => {
    if (X_API_TOKEN && (serverUrl.length > 0 || __DEV__)) {
      try {
        await Promise.all([
          getAllData({ mode: 'allData' }),
          getAllData({ mode: 'dealers' }),
          getAllData({ mode: 'portfolio-list' }),
        ]);
      } catch (e) {
        console.warn('refreshData error', e);
      }
    }
  };



  return (
    <APIContext.Provider value={{ getAllData,sendUserRequest, serverUrl, sendPostRequest, refreshData, handleToggleDiscountSwitch, getUtils, login, sendFormDataPostRequest }}>
      {children}
    </APIContext.Provider>
  );
};

export const useAPI = () => useContext(APIContext);
